import {
  PRESENCE_CLEAR,
  PRESENCE_LEASE_EXPIRED,
  PRESENCE_SNAPSHOT,
  PRESENCE_UPDATE,
} from "./presenceConstants";
import { shouldReplacePresence } from "../lib/normalizePresence";

export const initialPresenceState = {
  byUserId: {},
};

function upsert(state, row) {
  if (!row || row.userId == null) return state;
  const key = String(row.userId);
  const current = state.byUserId[key];
  if (!shouldReplacePresence(current, row)) {
    return state;
  }
  return {
    ...state,
    byUserId: {
      ...state.byUserId,
      [key]: row,
    },
  };
}

export default function presenceReducer(state = initialPresenceState, action) {
  switch (action.type) {
    case PRESENCE_SNAPSHOT: {
      const rows = Array.isArray(action.payload) ? action.payload : [];
      let next = state;
      for (const row of rows) {
        next = upsert(next, row);
      }
      return next;
    }
    case PRESENCE_UPDATE:
      return upsert(state, action.payload);
    case PRESENCE_LEASE_EXPIRED: {
      const userId = action.payload?.userId;
      const leaseExpiresAt = action.payload?.leaseExpiresAt;
      if (userId == null) return state;
      const key = String(userId);
      const current = state.byUserId[key];
      if (!current || !current.online) return state;
      // Ignore stale expiry timers superseded by a fresher lease.
      if (
        leaseExpiresAt
        && current.leaseExpiresAt
        && leaseExpiresAt !== current.leaseExpiresAt
      ) {
        return state;
      }
      return {
        ...state,
        byUserId: {
          ...state.byUserId,
          [key]: {
            ...current,
            online: false,
            leaseExpiresAt: null,
            updatedAtMs: Date.now(),
          },
        },
      };
    }
    case PRESENCE_CLEAR:
      return initialPresenceState;
    default:
      return state;
  }
}
